/**
 * The feature switches of the Access tab, in the groups they are shown in.
 * `key` is the form field (and the property of the formatted user it is read from);
 * `children` are switches shown under their parent while the parent is on.
 */
const AccessGroups = [
  {
    title: 'Detection engines',
    items: [
      {
        key: 'isEnableContentIntegrityEngine',
        label: 'Content Integrity Engine'
      },
      {
        key: 'isEnableImageEngine',
        label: 'Image Engine'
      },
      {
        key: 'isEnableNLPEngine',
        label: 'NLP Engine'
      },
      {
        key: 'isEnableJavaScriptMalwareEngine',
        label: 'JavaScript Malware Engine'
      },
      {
        key: 'isEnableVideoChangeEngine',
        label: 'Video Change Engine'
      }
    ]
  },
  {
    title: 'Monitoring',
    items: [
      {
        key: 'isEnablePageRender',
        label: 'Page Render'
      },
      {
        key: 'isEnableStatusCodeMonitoring',
        label: 'Status Code Monitoring'
      },
      {
        key: 'isEnableDndSslMonitoring',
        label: 'DNS/SSL/Whois Monitoring'
      },
      {
        key: 'isEnableFirecrawl',
        label: 'Website Crawl (Firecrawl)'
      },
      {
        key: 'isEnableChangeEvents',
        label: 'Change Events'
      }
    ]
  },
  {
    title: 'AI alert triage',
    items: [
      {
        key: 'isEnableAlertTriage',
        label: 'Alert Triage',
        children: [
          {
            key: 'isEnableFqdnAiTriagePrompt',
            label: 'AiTriage FQDN Prompt'
          },
          {
            key: 'isEnableFqdnAiTriagePreferences',
            label: 'AiTriage FQDN Preferences'
          }
        ]
      }
    ]
  },
  {
    title: 'Notifications',
    items: [
      {
        key: 'isEnableSMS',
        label: 'SMS'
      }
    ]
  }
];

export { AccessGroups };
